module.exports = new __parcel__URL__("portrait.3de315c1.jpg").toString();